"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/grid/grid");
/**
 * mm-feature 들을 열 단위로 묶는 그룹.
 * 레이아웃은 mm-grid에 위임하고, gap은 8로 내부에서 엄격하게 고정한다.
 */
let FeatureGroup = class FeatureGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.columns = 2;
    }
    render() {
        return (0, lit_1.html) `
      <mm-grid columns=${this.columns} gap="8" role="group">
        <slot></slot>
      </mm-grid>
    `;
    }
};
FeatureGroup.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], FeatureGroup.prototype, "columns", void 0);
FeatureGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-feature-group')
], FeatureGroup);
exports.FeatureGroup = FeatureGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZS1ncm91cC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZlYXR1cmUtZ3JvdXAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUkzRCx5Q0FBc0M7QUFFdEM7OztHQUdHO0FBRUksSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBYSxTQUFRLGdCQUFVO0lBQXJDOztRQU11QixZQUFPLEdBQTRCLENBQUMsQ0FBQTtJQVNsRSxDQUFDO0lBUEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7eUJBQ1UsSUFBSSxDQUFDLE9BQU87OztLQUdoQyxDQUFBO0lBQ0gsQ0FBQzs7QUFiTSxtQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7O0dBSWxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzZDQUFxQztBQU5yRCxZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBZXhCO0FBZlksb0NBQVkifQ==